// Test IDs for the Studio Legale one-page site.
export const SITE = {
  header: 'site-header',
  headerLogo: 'header-logo-link',
  navLink: (id) => `nav-link-${id}`,
  headerBookBtn: 'header-book-button',
  mobileMenuBtn: 'header-mobile-menu-button',
  mobileNavLink: (id) => `mobile-nav-link-${id}`,
  heroBookBtn: 'hero-book-button',
  heroCallBtn: 'hero-call-button',
  heroWhatsappBtn: 'hero-whatsapp-button',
  areaCard: (k) => `area-card-${k}`,
  promiseCard: (k) => `promise-card-${k}`,
  lawyerBioPlaceholder: 'lawyer-bio-placeholder',
  stepItem: (n) => `method-step-${n}`,
  bookingTabs: 'booking-tabs',
  tabAppointment: 'booking-tab-appointment',
  tabRequest: 'booking-tab-request',
  calendar: 'booking-calendar',
  slotBtn: (t) => `booking-slot-${t.replace(':', '')}`,
  slotsEmpty: 'booking-slots-empty',
  selectedSummary: 'booking-selected-summary',
  apptName: 'appointment-name-input',
  apptEmail: 'appointment-email-input',
  apptPhone: 'appointment-phone-input',
  apptArea: 'appointment-area-select',
  apptMessage: 'appointment-message-input',
  apptPrivacy: 'appointment-privacy-checkbox',
  apptSubmit: 'appointment-submit-button',
  apptSuccess: 'appointment-success',
  reqName: 'request-name-input',
  reqEmail: 'request-email-input',
  reqPhone: 'request-phone-input',
  reqArea: 'request-area-select',
  reqMessage: 'request-message-input',
  reqPrivacy: 'request-privacy-checkbox',
  reqSubmit: 'request-submit-button',
  reqSuccess: 'request-success',
  contactPhone: 'contact-phone-link',
  contactWhatsapp: 'contact-whatsapp-link',
  contactEmail: 'contact-email-link',
  contactPec: 'contact-pec-link',
  contactAddress: 'contact-address',
  contactMap: 'contact-map',
  floatingWhatsapp: 'floating-whatsapp-button',
  footer: 'site-footer',
  footerVat: 'footer-vat-placeholder',
};
